import styled from 'styled-components';
import FormGroup from '@omilia/form-group';

export const SForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > div:nth-child(3) {
    align-self: flex-end;
    margin-top: 20px;
  }

  & > div > div > ul {
    margin: 14px 0 0 0;
  }
`;

export const SFormGroup = styled(FormGroup)`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 15px;

  & > div > div {
    min-width: 0;
  }
`;

export const SModalBody = styled.div`
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SModalFooter = styled.div`
  display: flex;
  flex: 1;
`;
